import { ComponentType } from 'react'
import { connect } from 'react-redux'
import type { ReduxAppState } from './store'
import * as authActions from './auth/actions'

/** Auth-only state mapper — only subscribes to the auth slice */
const mapAuthState = (state: ReduxAppState) => ({
  auth: state.auth,
})

/** Auth-only connector — public components (AuthorizedComponent, PublicHeader, LoginModal, AppRoutes) */
export function withReduxAuth(component: ComponentType<any>): ComponentType<any> {
  return connect(mapAuthState, authActions)(component)
}